import { render, staticRenderFns } from "./MiniProgramDouMaiKeJiWxUsers.vue?vue&type=template&id=27f1784b&scoped=true&"
import script from "./MiniProgramDouMaiKeJiWxUsers.vue?vue&type=script&lang=js&"
export * from "./MiniProgramDouMaiKeJiWxUsers.vue?vue&type=script&lang=js&"
import style0 from "./MiniProgramDouMaiKeJiWxUsers.vue?vue&type=style&index=0&id=27f1784b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f1784b",
  null
  
)

export default component.exports